import { date, number, object, string } from "yup";

export const maintenanceLogValidationSchema = object({
  titre: string().required("Le titre est requis"),
  description: string().optional(),
  date_intervention: date().optional(),
  cout: number().min(0, "Le coût doit être positif").optional(),
});

export const MAINTENANCE_LOG_INITIAL_VALUE = {
  titre: "",
  description: "",
  date_intervention: "",
  cout: "",
};
